import React from 'react';

const Confirm = ({ isOpen, onConfirm, onCancel, message, title = 'Confirm Action', type = 'warning' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'bi-check-circle-fill text-success';
      case 'error':
        return 'bi-exclamation-triangle-fill text-danger';
      case 'warning':
        return 'bi-exclamation-circle-fill text-warning';
      case 'danger':
        return 'bi-exclamation-triangle-fill text-danger';
      default:
        return 'bi-info-circle-fill text-info';
    }
  };

  const getAlertClass = () => {
    switch (type) {
      case 'success':
        return 'alert-success';
      case 'error':
        return 'alert-danger';
      case 'warning':
        return 'alert-warning';
      case 'danger':
        return 'alert-danger';
      default:
        return 'alert-info';
    }
  };

  const getConfirmButtonClass = () => {
    switch (type) {
      case 'success':
        return 'btn-success';
      case 'error':
        return 'btn-danger';
      case 'warning':
        return 'btn-warning';
      case 'danger':
        return 'btn-danger';
      default:
        return 'btn-primary';
    }
  };

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onCancel}>
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className={`modal-header ${getAlertClass()}`}>
            <div className="d-flex align-items-center">
              <i className={`bi ${getIcon()} me-3 fs-2`}></i>
              <h5 className="modal-title mb-0">SportsBid Arena</h5>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-header">
            <h5 className="modal-title mb-0">{title}</h5>
          </div>
          <div className="modal-body text-center">
            <p className="mb-0">{message}</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={onCancel}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancel
            </button>
            <button
              type="button"
              className={`btn ${getConfirmButtonClass()}`}
              onClick={onConfirm}
            >
              <i className="bi bi-check-circle me-2"></i>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm;